"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
function Notification(props) {
    const show = !!props.message.trim();
    return (0, jsx_runtime_1.jsx)("div", Object.assign({ className: `klip-qrcode__notification${show ? ' notification__show' : ''}` }, { children: props.message }));
}
exports.default = Notification;
